<template>
  <div class="studies">
    <div class="studies__table-wrapper">
      <custom-table
        :title="title"
        :tableData="dataArray"
        :pagesCount="pagesCount"
        :paginationMethod="'fetchStudies'"
        class="studies__table"
        :extLoading="loading"
      >
        <template slot="headerData">
          <div class="table__flex-header">
            <div class="table__title">{{ title }}</div>
          </div>
        </template>
        <template slot="thead">
          <th>Name</th>
          <th>Created</th>
        </template>
        <template slot-scope="{ row }">
          <td>{{ row.name }}</td>
          <td>{{ row.created_at }}</td>
          <td>
            <drop-down tag="div" title="Options">
              <a class="dropdown-item" @click="showDatapoints(row.id)"
                >Show datapoints</a
              >
              <a class="dropdown-item" @click="modalToggle(row.id)">Delete</a>
            </drop-down>
          </td>
        </template>
      </custom-table>
    </div>

    <new-studies class="studies__form"></new-studies>
  </div>
</template>

<script>
import { apiError } from "@/util/ErrorMessage.js";
import CustomTable from "../../customReusableComponents/CustomTable";
import NewStudies from "./NewStudies/NewStudies";

export default {
  components: { CustomTable, NewStudies },
  data() {
    return {
      title: "STUDIES",
      showModal: false,
      loading: false
    };
  },
  computed: {
    pagesCount() {
      const entries = this.$store.getters.getStudiesQuantity;
      return Math.ceil(entries / 5);
    },
    dataArray() {
      const entries = this.$store.getters.studies;
      entries.map(item => {
        item.created_at = this.convertData(item.created_at);
      });
      return entries;
    }
  },
  methods: {
    convertData(data) {
      return new Date(data)
        .toDateString()
        .split(" ")
        .slice(1, 4)
        .join(" ");
    },
    modalToggle(id) {
      this.$store.dispatch("toggleModal");
      this.$store.dispatch("sendStudyIdToModal", id);
    },
    showDatapoints(id) {
      this.$store.dispatch("setStudiesFilter", `study=${id}`);
      this.$store.dispatch("setPatientIdFilter", "");
      this.$router.push({ path: "datapoints" });
    }
  },
  async created() {
    this.loading = true;

    try {
      await this.$store.dispatch("fetchStudies", 1);
    } catch (error) {
      apiError(error, this);
    }

    this.loading = false;
  }
};
</script>
<style lang="scss">
.studies {
  display: flex;
  justify-content: space-between;

  @media only screen and (min-width: 320px) and (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }

  &__table-wrapper {
    width: 60%;
    overflow: auto;

    @media only screen and (min-width: 320px) and (max-width: 768px) {
      width: 100%;
      margin-bottom: 10px;
    }
  }

  &__table {
    width: 100%;
  }

  &__form {
    width: 35%;

    @media only screen and (min-width: 320px) and (max-width: 480px) {
      width: 100%;
    }
  }
}
</style>
